import React, { useMemo } from 'react';

import RainbowTableModal from '@/pages/dashboard/components/RainbowTableModal';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { useD2D3D7Text } from '../../hooks';
import { getLanguage } from '@home/utils/common';
import { resolveConfigString } from '@/pages/dashboard/utils/metricUtils';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';

const RealtimeUserRainbowModal = (props: any) => {
  const { visible = false, setVisible, isInflexion = false, data: propsData, metricsWidth, modalTitle, metricsInfo } = props;
  const { isEN, getLocalText } = useLocal();
  const { getD2D3D7Text } = useD2D3D7Text();
  // getD2D3D7Text
  const columns = [
    {
      key: 'metrics',
      header: getLocalText('realtime_metrics_card_modal_table_header_metrics'),
      width: metricsWidth ? metricsWidth : 40,
      render: (cvm: any) => {
        const isString = typeof cvm?.metrics === 'string';
        return isString ? <FormatHtmlTextToReact text={cvm?.metrics || ""} /> : <div>{cvm?.metrics || ""}</div>;
      },
    },
    {
      key: 'explanation',
      header: getLocalText('realtime_metrics_card_modal_table_header_explanation'),
      width: 200,
      render: (cvm: any) => {
        const isString = typeof cvm?.explanation === 'string';
        return isString ? <FormatHtmlTextToReact text={cvm?.explanation || ""} /> : <div>{cvm?.explanation || ""}</div>;
      },
    },
  ];
  const metricsData = useMemo(() => {
    return propsData?.map((item: any) => {
      const { metricsEn, metricsCn, titleEn, titleCn, explainEn, explainCn } = item || {};
      return {
        metrics: getLanguage(isEN, resolveConfigString(metricsEn || titleEn, metricsInfo), resolveConfigString(metricsCn || titleCn, metricsInfo)),
        explanation: getLanguage(isEN, resolveConfigString(explainEn, metricsInfo), resolveConfigString(explainCn, metricsInfo))
      };
    });
  }, [propsData, metricsInfo, isEN]);
  const data = propsData ? metricsData : [
    {
      metrics: getLocalText('realtime_metrics_card_modal_table_new_users'),
      explanation: getLocalText('realtime_metrics_card_modal_table_new_users_explain')
    },
    {
      metrics: getLocalText('realtime_metrics_card_modal_table_active_users'),
      explanation: getLocalText('realtime_metrics_card_modal_table_active_users_explain')
    },
    {
      metrics: getLocalText('realtime_metrics_card_modal_table_online_users'),
      explanation: getLocalText('realtime_metrics_card_modal_table_online_users_explain')
    },
    {
      metrics: getD2D3D7Text('d2CardTitle'),
      explanation: getD2D3D7Text('d2Explain'),
      hidden: isInflexion,
    },
    {
      metrics: getD2D3D7Text('d3CardTitle'),
      explanation: getD2D3D7Text('d3Explain'),
      hidden: isInflexion,
    },
    {
      metrics: getD2D3D7Text('d7CardTitle'),
      explanation: getD2D3D7Text('d7Explain'),
      hidden: isInflexion,
    },
    {
      metrics: getLocalText('realtime_metrics_card_modal_table_dod'),
      explanation: (
        <>
          <p>{getLocalText('realtime_metrics_card_modal_table_dod_explain_1')}</p>
          <p>{getLocalText('realtime_metrics_card_modal_table_dod_explain_2')}</p>
        </>
      )
    },
    {
      metrics: getLocalText('realtime_metrics_card_modal_table_sdlw'),
      explanation: (
        <>
          <p>{getLocalText('realtime_metrics_card_modal_table_sdlw_explain_1')}</p>
          <p>{getLocalText('realtime_metrics_card_modal_table_sdlw_explain_2')}</p>
        </>
      )
    },
  ];
  const caption = modalTitle || getLocalText('realtime_metrics_card_modal_title');
  return (
    <RainbowTableModal data={isInflexion ? data?.filter(v => !v?.hidden) : data} columns={columns} caption={caption} visible={visible} setVisible={setVisible} />
  );
};

export default RealtimeUserRainbowModal;